"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatTime(seconds) {
    var isValid = !isNaN(seconds) && isFinite(seconds);
    var isNegative = isValid && seconds < 0;
    var date = new Date(null);
    date.setSeconds(isValid ? Math.abs(Math.floor(seconds)) : 0);
    // get HH:mm:ss part, remove hours if they are "00:"
    var time = date
        .toISOString()
        .substr(11, 8)
        .replace(/^00:/, '');
    return isNegative ? "-".concat(time) : time;
}
exports.default = formatTime;
//# sourceMappingURL=formatTime.js.map